<template>
  <div>
    <CCard class="mob-pd-0px">
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <div class="row flex-flow-column">
          <div class='col'>
            <p>{{GET_SEL_SUPPLIER_GRP? $t("newSupplierGroup.updateTitle"):$t("newSupplierGroup.title") }}</p>
          </div>

          <p class="desc">{{ $t("newSupplierGroup.desc") }}</p>
        </div>
      </CCardHeader>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(toSaveSupplierGrp)">
          <CCardBody class="user-manage-table pt-0px max-width-550 m-auto">
            <div class="w-100 max-w-850">
              <div class="row mt-20px mb-20px">
                <div class="col-md-12 col-sm-12 mb-10px">
                  <cStatusButton
                  v-if="GET_SEL_SUPPLIER_GRP"
                    class="generate-ex-btn label-margin-unset"
                    :isConfirm="false"
                    :defaultStatus="GET_SEL_SUPPLIER_GRP!=null? GET_SEL_SUPPLIER_GRP.isactive : supGrp.isactive"
                    @change="supGrp.isactive=!supGrp.isactive"
                    :label="{checked: $t('newSupplierGroup.active'), unchecked: $t('newSupplierGroup.inactive')}"
                  ></cStatusButton>
                  <br />
                </div>
                
                <div class="col-md-12 col-sm-12 mb-10px">
                  <cTextInputComponent
                    v-model="supGrp.grpName"
                    :placeholder="$t('newSupplierGroup.grpNamePlc')"
                    :name="$t('newSupplierGroup.suppGrpName')"
                    :label="$t('newSupplierGroup.suppGrpName')"
                    class
                    rules="required|noInitialSpace|max:150"
                  />
                </div>
                
                <div class="col-md-12 col-sm-12 mb-10px">
                  <cTextInputComponent
                    v-model="supGrp.cnctNo"
                    :placeholder="$t('newSupplierGroup.contNumPlc')"
                    :name="$t('newSupplierGroup.contNumber')"
                    :label="$t('newSupplierGroup.contNumber')"
                    rules="required|noInitialSpace|int_phone_number|max:15"
                    class
                  />
                </div>
                <div class="col-md-12 col-sm-12 mb-10px">
                  <cTextInputComponent
                    v-model="supGrp.mail"
                    :placeholder="$t('newSupplierGroup.emailPlc')"
                    :name="$t('newSupplierGroup.email')"
                    :label="$t('newSupplierGroup.email')"
                    rules="required|email"
                    class
                  />
                </div>
                <div class="col-md-12 col-sm-12 mb-10px">
                  <cTextInputComponent
                    v-model="supGrp.name"
                    :placeholder="$t('newSupplierGroup.namePlc')"
                    :name="$t('newSupplierGroup.contactPer')"
                    :label="$t('newSupplierGroup.contactPer')"
                    rules="required|noInitialSpace|onlyAlphabets|max:50"
                    class
                  />
                </div>
               
                <div class="col-md-12 col-sm-12 mb-10px">
                  <div class>
                    <div class="row">
                      <div class="col-7">
                        <label>{{$t('newSupplierGroup.country')}}</label>
                        <div class>
                          <ValidationProvider
                            class="w-100"
                            tag="div"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <multiselect
                              :searchable="true"
                              
                            :allow-empty="false"
                              :close-on-select="true"
                              :track-by="'country'"
                              :label="'country'"
                              v-model="supGrp.cntryId"
                              :show-labels="false"
                              :options="lsCountryRoute"
                               @input="onSelCountry"
                              :placeholder="$t('newSupplierGroup.select')"
                            >
                            <template slot="singleLabel" slot-scope="{ option }">
              <div v-if="option['country']">
                {{  option['country'] | hmsCountryName }}
                </div>
            </template>
                            <template slot="option" slot-scope="props">
                  <div class="d-flex">
                    <span>{{ props.option['country'] | hmsCountryName }}</span>
                     <strong v-if="props.option['name']!='All'" class="right ml-auto">
                                          {{
                                          props.option['country']
                                          }}
                                        </strong>
                  </div>
                </template>
                              <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                              
                                <span>{{ errors[0] }}</span>
                             
                            </div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                
                <div class="col-md-12 col-sm-12 mb-10px">
                  <div class="row">
                    <div class="col-12">
                      <label>{{$t('newSupplierGroup.city')}}</label>
                      <div class>
                        <ValidationProvider
                          class="w-100"
                          tag="div"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <multiselect
                            :searchable="true"
                            :close-on-select="true"
                            :track-by="'code'"
                            :label="'cityname'"
                            :allow-empty="false"
                            v-model="supGrp.city"
                            :show-labels="false"
                            :options="cityLs"
                             @input="onSelCity"
                            :placeholder="$t('newSupplierGroup.select')"
                          >
                           <template slot="option" slot-scope="props">
                  <div class="d-flex">
                    <span>{{ props.option['cityname'] }}</span>
                     <strong class="right ml-auto">
                                          {{
                                          props.option['code']
                                          }}
                                        </strong>
                  </div>
                </template>
                           <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                          </multiselect>
                          <div v-if="errors && errors[0]" class="invalid-feedback icon">
                            
                              <span>{{ errors[0] }}</span>
                           
                          </div>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <cAlertModal
              v-if="isShowAlertModal"
              :key="'CA'+alertCount"
              :buttonList="modalButton"
              :status="modalStatus"
              :isShowIcon="true"
              :show="isShowAlertModal"
              :desc="confirmTxt"
            ></cAlertModal>

            <CRow>
              <CAlert v-if="alertValue" show color="danger">
                <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                  <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
                </div>
                <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                  <span>{{$t("cAlert.errorCode")+' : '}}</span>
                  <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
                </div>
                <div v-if="alertValue&&alertValue.constructor==String">
                  <p>{{alertValue}}</p>
                </div>
              </CAlert>
            </CRow>
            
          </CCardBody>
          <CCardFooter>
            <CRow class="justify-content-end">
              <CButton
                @click="navigateToAllSuppGrp()"
                color="danger"
                class="action-c-btn mr-15px"
              >{{$t('newSupplierGroup.cancel')}}</CButton>
              <CButton
                col="12"
                type="submit"
                color="success removewrap"
                class="action-c-btn mr-15px"
              >{{ GET_SEL_SUPPLIER_GRP? $t('newSupplierGroup.update') : $t('newSupplierGroup.create')}}</CButton>
            </CRow>
          </CCardFooter>
        </form>
      </ValidationObserver>
    </CCard>
  </div>
</template>

<script>
import router, { navigate, updateDataEdited } from "../../../../router/index";
import cTextInputComponent from "../../../../components/form/cTextInputComponent";
import { mapGetters, mapActions } from "vuex";
import { ValidationProvider } from "vee-validate";

import apiGetCitiesforHotel from "../../../../services/apiGetCitiesforHotel.js";

import {
  PATHNAME,
  COMPONENT_NAME,
  DATE_TIME_FORMAT,
  ALERT_MODAL_STATUS,
} from "../../../../util/constants";
import apiCreateSupplierGrp from "../../../../services/apiCreateSupplierGrp";
import apiUpdateSupplierGrp from "../../../../services/apiUpdateSupplierGrp";
import Logger from "../../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
} from "../../../../config/API_DATA";
import cAlertModal from "../../../../components/form/cAlertModal";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,GroupByList, cloneData, cloneDeep 
} from "../../../../util/util";
import BaseConfiguration from "../../../../config/base.js";
import cStatusButton from "../../../../components/form/cStatusButton";
import HotelDatePicker from "vue-range-datechooser";
import multiselect from "vue-multiselect";
import { isPastDate } from "../../../../util/date/dateFunctions";

import { ValidationObserver, localize, Validator } from "vee-validate";
import { VMdDateRangePicker } from "material-vue-date-picker";
import datePickerInput from "../../../../components/datePicker/datePickerInput";
import cDropDown from "../../../../components/form/cDropDown";
import cRadioButton from "../../../../components/form/cRadioButton";
import { i18n } from "../../../../plugins/i18n.js";

export default {
  name: COMPONENT_NAME.SUPPLIER_GROUP_NEW,
  components: {
    ValidationProvider,
    ValidationObserver,
    datePickerInput,
    VMdDateRangePicker,
    cStatusButton,
    HotelDatePicker,
    cTextInputComponent,
    multiselect,
    cAlertModal,
    cDropDown,
    cRadioButton,
  },

  data: () => {
    return {
      alertValue: null,
      supGrp:{
          grpName: null,
          cntryId: null,
          city: null,
          cnctNo: null,
          mail: null,
          name: null,
          isactive: false,
      },
      lsCountryRoute: [],
      cityLs: [],
      modalStatus: ALERT_MODAL_STATUS.INFO,
      modalButton: null,
      isShowAlertModal: false,
      confirmTxt:null,
      alertCount:0,
     
    };
  },

  methods: {
      ...mapActions("sHotelSearch", {
      SET_HOTEL_ROUTES_OBJ: "SET_HOTEL_ROUTES_OBJ",
      SET_HOTEL_SEARCH_OBJ: "SET_HOTEL_SEARCH_OBJ"}),

 

    navigateToAllSuppGrp() {
      try {
        if (BaseConfiguration.isDebug) console.log("navigateToFareView");

        navigate(PATHNAME.SUPPLIER_GROUP_ALL);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SUPPLIER_GROUP_NEW,
          "error in navigateToFareView",
          err.toString(),
          "navigateToFareView",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },


    

    async CreateSupplierGrp() {
      if (BaseConfiguration.isDebug) console.log("CreateSupplierGrp");
      let returnValue;
      try {
        this.isShowAlertModal = false;
        updateDataEdited(false);
        let CreateSupplierGrpReq = apiCreateSupplierGrp.buildRequest(this.supGrp); //constant
        this.isShowAlertModal = false;
        if (CreateSupplierGrpReq != null) {
          let CreateSupplierGrpRes = await apiCreateSupplierGrp.getResponse(
            CreateSupplierGrpReq
          );
          if (VALIDATE_SUCCESS_RES(CreateSupplierGrpRes)) {
            returnValue = CreateSupplierGrpRes.data.data;
            this.showAlertModal(
              ALERT_MODAL_STATUS.SUCCESS,
              this.$t("newSupplierGroup.addSuccess")
            );
            this.alertValue = null;
          } else {
            let error = getErrorMessage(CreateSupplierGrpRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error, true, true);
            }
            this.showAlertModal(ALERT_MODAL_STATUS.FAIL, this.alertValue);
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
         COMPONENT_NAME.SUPPLIER_GROUP_NEW,
          "error in  getCreateSupplierGrp",
          err.toString(),
          "getCreateSupplierGrp()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },


    async UpdateSupplierGrp() {
      if (BaseConfiguration.isDebug) console.log("UpdateSupplierGrp");
      let returnValue;
      try {
        this.isShowAlertModal = false;
        updateDataEdited(false);
        let UpdateSupplierGrpReq = apiUpdateSupplierGrp.buildRequest(
           this.supGrp,
           this.GET_SEL_SUPPLIER_GRP
        ); //constant

        if (UpdateSupplierGrpReq != null) {
          let UpdateSupplierGrpRes = await apiUpdateSupplierGrp.getResponse(
            UpdateSupplierGrpReq
          );
          if (VALIDATE_SUCCESS_RES(UpdateSupplierGrpRes)) {
            returnValue = UpdateSupplierGrpRes.data.data;

            this.showAlertModal(
              ALERT_MODAL_STATUS.SUCCESS,
              this.$t("newSupplierGroup.editSuccess")
            );
            this.alertValue = null;
          } else {
            let error = getErrorMessage(UpdateSupplierGrpRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error, true, true);
            }
            this.showAlertModal(ALERT_MODAL_STATUS.FAIL, this.alertValue);
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SUPPLIER_GROUP_NEW,
          "error in  getUpdateSupplierGrp",
          err.toString(),
          "getUpdateSupplierGrp()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    onSelCity(pSelCity) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSelCity");
        this.supGrp.city = pSelCity;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SUPPLIER_GROUP_NEW,
          "error in onSelCity",
          err.toString(),
          "onSelCity",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

     onSelCountry(pSelCountry) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSelCountry");
        this.supGrp.cntryId = pSelCountry;
        let defCity = this.getDefCity(this.lsCountryRoute,this.supGrp.cntryId);
          if (defCity) {
              this.cityLs = defCity
            this.supGrp.city = defCity[0];
          } 
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SUPPLIER_GROUP_NEW,
          "error in onSelCountry",
          err.toString(),
          "onSelCountry",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },



    toSaveSupplierGrp() {
      try {
        if (BaseConfiguration.isDebug) console.log("toSaveSupplierGrp");
        
          this.GET_SEL_SUPPLIER_GRP
            ? this.showAlertModal(
                ALERT_MODAL_STATUS.INFO,
                this.$t("newSupplierGroup.editConfirm")
              )
            : this.showAlertModal(
                ALERT_MODAL_STATUS.INFO,
                this.$t("newSupplierGroup.addConfirm")
              );
        
      } catch (err) {
        let body = Logger.buildRequest(
         COMPONENT_NAME.SUPPLIER_GROUP_NEW,
          "error in toSaveSupplierGrp",
          err.toString(),
          "toSaveSupplierGrp",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    showAlertModal(status, val) {
      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;

      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("newSupplierGroup.no"),
            func: this.toggleShowAlertModal,
          },
          {
            name: this.$t("newSupplierGroup.yes"),
            func: this.GET_SEL_SUPPLIER_GRP
              ? this.UpdateSupplierGrp
              : this.CreateSupplierGrp,
          },
        ];
      } else if (
        status == ALERT_MODAL_STATUS.SUCCESS 
      ) {
        this.modalButton = [
          {
            name: this.$t("newSupplierGroup.ok"),
            func: this.navigateToAllSuppGrp,
          },
        ];
      }else if (status == ALERT_MODAL_STATUS.FAIL) {
        this.modalButton = [
          {
            name: this.$t("supplierGroup.ok"),
            func: this.toggleShowAlertModal
          }
        ];
      }
      this.confirmTxt = val;
    },

    

    toggleShowAlertModal() {
      //  updateDataEdited(true);
      this.isShowAlertModal = !this.isShowAlertModal;
      this.modalStatus = ALERT_MODAL_STATUS.INFO;
    },

    assignContractObj(pCountryOp, pSelContract) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignContractObj");

        this.supGrp.grpName = pSelContract.name;
        this.supGrp.cnctNo = pSelContract.contactNumber;
        for (let i = 0; i < pCountryOp.length; i++) {
          if (pCountryOp[i].country == pSelContract.countryCode) {
            this.supGrp.cntryId = pCountryOp[i];
            break;
          } else {
            this.supGrp.cntryId = null;
          }
        }
        let cityOp = this.getDefCity(pCountryOp,this.supGrp.cntryId);
          if (cityOp) {
              this.cityLs = cityOp
            
          } 
        for (let i = 0; i < this.cityLs.length; i++) {
          if (this.cityLs[i].code == pSelContract.cityCode) {
          this.supGrp.city = this.cityLs[i];
            break;
          } else {
            this.supGrp.city = null;
          }
        }
        this.supGrp.isactive = pSelContract.isactive;
        this.supGrp.mail = pSelContract.contactEmail;
        this.supGrp.name = pSelContract.contactPersonname;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SUPPLIER_GROUP_NEW,
          "error in assignContractObj",
          err.toString(),
          "assignContractObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getDefCountry(pCountryLs) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getDefCountry");
        // for (let i = 0; i < pCountryLs.length; i++) {
        //   if (
        //     pCountryLs[i].airline_code == BaseConfiguration.defaultAirlineCode
        //   ) {
        //     retValue = pCountryLs[i];
        //     break;
        //   }
        // }
        retValue = pCountryLs[0];
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SUPPLIER_GROUP_NEW,
          "error in getDefCountry",
          err.toString(),
          "getDefCountry",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getDefCity(pCountryLs,pDefCntry) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getDefCity");
        for (let i = 0; i < pCountryLs.length; i++) {
            
          if (
            pCountryLs[i].country == pDefCntry.country
          ) {
            retValue = pCountryLs[i].cityLs;
            break;
          }
        }
        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SUPPLIER_GROUP_NEW,
          "error in getDefCity",
          err.toString(),
          "getDefCity",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

     async getRoutesResponse() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRoutesResponse");

        let getRoutesRequest = apiGetCitiesforHotel.buildRequest();

        if (getRoutesRequest) {
          // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
          let getRouteResponse = await apiGetCitiesforHotel.getResponse(
            getRoutesRequest
          );

          if (VALIDATE_SUCCESS_RES(getRouteResponse)) {
            // this.SET_AGENCY_RES(getRoutesResponse); //save res in store
            retValue = getRouteResponse.data.data;
            this.SET_HOTEL_ROUTES_OBJ(retValue);
          } else {
            let error = getErrorMessage(getRouteResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SUPPLIER_GROUP_NEW,
          "error while getting response from get Routes response API",
          err.toString(),
          "getRoutesResponse",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
},

     ///method to get routes for particular country
    getRoutesForHotel() {
      try {
        if (BaseConfiguration.isDebug) console.log("getRoutesForHotel");

       
        let routes = this.routesResponse;
        // let countries = [];
        // let listOfRoutes = [];

        // for (let i = 0; i < routes.length; i++) {
        //  countries.push(routes[i].country)
               
        // }

        // countries = [...new Set(countries)];

        // var routesGrpByList = GroupByList(routes, "country", "arrCombination"); ///list of routes grouped by depcode
        // for (let i = 0; i < countries.length; i++) {
        //   for (let j = 0; j < routes.length; j++) {
        //     let lsArrCodes = [];
        //     if (countries[i] == routes[j].country) {
            

        //       listOfRoutes.push(routes[j]); ///list of routes for particular country
        //     }
        //   }

        //   let countryRoute = {
        //     country: countries[i],
        //     routeList: listOfRoutes,
        //   };
        //   listOfRoutes = [];
        //   this.lsCountryRoute.push(countryRoute);
        // }
        // let startCountry = cloneData(this.lsCountryRoute[0]);
        // for (let index = 0; index < this.lsCountryRoute.length; index++) {
        //   const countryObj = this.lsCountryRoute[index];
        //   if (
        //     countryObj.country.countrycode ==
        //     BaseConfiguration.defaultCountryValue
        //   ) {
        //     this.lsCountryRoute[0] = countryObj;
        //     this.lsCountryRoute[index] = startCountry;
        //     break;
        //   }
        // }
        var routesGrpByList = GroupByList(routes.cityArray,'country','cityLs');
        this.lsCountryRoute = routesGrpByList;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SUPPLIER_GROUP_NEW,
          "error while formatting routes",
          err.toString(),
          "getRoutesForHotel",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  },

  async created() {
    try {
      if (this.GET_SEL_SUPPLIER_GRP) {
        // this.contract.isActive = this.GET_SEL_SUPPLIER_GRP.isactive;

      }
    if (this.routeObj != null) {
        this.routesResponse = cloneDeep( this.routeObj);
      } else {
        this.routesResponse = await this.getRoutesResponse();
      }
      if (this.routesResponse != null) {
        this.getRoutesForHotel();
      }

      if (this.GET_SEL_SUPPLIER_GRP ) {
        this.assignContractObj(this.lsCountryRoute,
          this.GET_SEL_SUPPLIER_GRP
        );
     } else {
        if (this.lsCountryRoute) {
          let defCountry = this.getDefCountry(this.lsCountryRoute);
          if (defCountry) {
            this.supGrp.cntryId = defCountry;
          }
          if(this.supGrp.cntryId){
           let defCity = this.getDefCity(this.lsCountryRoute,this.supGrp.cntryId);
          if (defCity) {
              this.cityLs = defCity
            this.supGrp.city = defCity[0];
          }   
          }
        }
      }

      updateDataEdited(true);
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.SUPPLIER_GROUP_NEW,
        "error in  Created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  computed: {
    ...mapGetters("sSupplierGrp", {
      GET_SEL_SUPPLIER_GRP: "GET_SEL_SUPPLIER_GRP",
    }),
     ...mapGetters("sHotelSearch", {
      routeObj: "GET_HOTEL_ROUTES_OBJ",
    }),
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.SUPPLIER_GROUP_NEW);
  },

  beforeDestroy() {
    removeClassBody();
  },
};
</script>
